export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14504.c960d913.jpg";